import type { Resolver } from "react-hook-form"
import { useForm as useRHForm } from "react-hook-form"

import { zodResolver } from "@hookform/resolvers/zod"
import type { z } from "zod"

import type { UseFormOptions } from "./use-form-types"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useForm = <TSchema extends z.ZodType<any, any>>({
  schema,
  mode = "onBlur",
  ...rest
}: UseFormOptions<TSchema>) => {
  const useFormMethods = useRHForm<z.infer<TSchema>>({
    ...rest,
    mode,
    resolver: zodResolver(schema) as unknown as Resolver<z.infer<TSchema>>,
  })

  return useFormMethods
}
